import firebase from 'firebase';


const config = {
    apiKey: "AIzaSyA0x6Siz-zCidSkcGZL4PhldeIeuXm7VNI",
    authDomain: "storeapp-61b49.firebaseapp.com",
    projectId: "storeapp-61b49",
    storageBucket: "storeapp-61b49.appspot.com",
    messagingSenderId: "580517618256",
    appId: "1:580517618256:web:fbebc874ffe5ca83466755",
    measurementId: "G-S27934WFM4"
  };

  const firebaseApp = firebase.initializeApp(config);
  export const db =  firebaseApp.firestore();
  export const storage = firebase.storage();
 
